import { GoogleOAuthProvider } from '@react-oauth/google'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import React from 'react'
import { AuthProvider } from '../context/AuthContext'
import { BreadcrumbProvider } from '../context/BreadcrumbContext'
import { SocketProvider } from '../context/SocketContext'
import { queryClient } from '../lib/queryClient'
import { config } from '../config'

const AppProviders: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	return (
		<GoogleOAuthProvider clientId={config.googleClientId}>
			<QueryClientProvider client={queryClient}>
				<AuthProvider>
					<SocketProvider>
						<BreadcrumbProvider>
							{children}
							<ReactQueryDevtools initialIsOpen={false} />
						</BreadcrumbProvider>
					</SocketProvider>
				</AuthProvider>
			</QueryClientProvider>
		</GoogleOAuthProvider>
	)
}

export default AppProviders
